// extracted by mini-css-extract-plugin
export default {"container":"bets_container__iT9Pk","title":"bets_title__chZe0","table":"bets_table__rytSc","table_row":"bets_table_row__Oh1G2","table_avatar":"bets_table_avatar__MxxwH"};